import create, { StoreApi } from 'zustand'
import { devtools } from 'zustand/middleware'
import createBaseSlice, { TBaseSlice } from './slice/baseSlice'
import createKeywordSlice, { TKeywordSlice } from './slice/keywordSlice'
import createOrderSlice, { TOrderSlice } from './slice/orderSlice'
import createSelectSlice, { TSelectSlice } from './slice/selectSlice'

export type TActivityFilterItem = {
  id: string
  label: string
  from?: number | null
  to?: number | null
}

export type TActivityFilterStore = TKeywordSlice &
  TSelectSlice &
  TOrderSlice &
  TBaseSlice

export type TFilterData = Pick<TActivityFilterStore, 'selectedFilter'>

export type TStoreSlice<T> = (
  set: StoreApi<T & TActivityFilterStore>['setState'],
  get: StoreApi<T & TActivityFilterStore>['getState'],
) => T

const useActivityFilterStore = create<TActivityFilterStore>()(
  devtools((set, get) => ({
    ...createKeywordSlice(set, get),
    ...createOrderSlice(set, get),
    ...createSelectSlice(set, get),
    ...createBaseSlice(set, get),
  })),
)

export default useActivityFilterStore
